<template lang="pug">
  v-app
    component(:is="layout")
      router-view(:key="$route.name")
      v-snackbar(
        v-model="showAlert",
        :color="alertMessage.type",
        content-class="d-flex align-center justify-space-between",
        :timeout=5000,
      ) {{ alertMessage.message }}
        v-btn(dark, text, @click="showAlert = false") Close
      PopupLogViewer
</template>

<script>
import Default from '@/layouts/Default.vue';
import PopupLogViewer from '@/components/elements/PopupLogViewer.vue';

// Shared devices (e.g. one tablet used by multiple staff at a shop) must not
// stay "logged in" as whoever used it last once nobody's actually there, or
// the next staff member's scans get attributed to them. Log out after this
// much idle time even though the session cookie itself lasts longer (12h).
const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const ACTIVITY_THROTTLE_MS = 5000;
const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'scroll'];

export default {
  name: 'App',
  components: {
    Default,
    PopupLogViewer,
  },

  data: () => ({
    showAlert: false,
    alertMessage: {},
    idleTimer: null,
    lastActivityAt: 0,
  }),

  computed: {
    layout() {
      return this.$route.meta.layout || 'Default';
    },
  },

  created() {
    window.$eventHub.$on('showAlert', this.showAlertSnackBar);
    window.$eventHub.$on('flushUser', this.flushUser);

    ACTIVITY_EVENTS.forEach(event =>
      window.addEventListener(event, this.registerActivity, { passive: true }),
    );
    this.resetIdleTimer();
  },

  beforeDestroy() {
    window.$eventHub.$off('showAlert', this.showAlertSnackBar);
    window.$eventHub.$off('flushUser', this.flushUser);

    ACTIVITY_EVENTS.forEach(event =>
      window.removeEventListener(event, this.registerActivity),
    );
    clearTimeout(this.idleTimer);
  },

  methods: {
    showAlertSnackBar(alert) {
      this.alertMessage = alert;
      this.showAlert = true;
    },

    flushUser() {
      this.$store.dispatch('auth/flush');
      this.$router.push({ name: 'login' });
    },

    registerActivity() {
      const now = Date.now();
      if (now - this.lastActivityAt < ACTIVITY_THROTTLE_MS) return;
      this.lastActivityAt = now;
      this.resetIdleTimer();
    },

    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.handleIdleTimeout, IDLE_TIMEOUT_MS);
    },

    handleIdleTimeout() {
      if (!this.$store.getters['auth/auth'].role) return;

      this.showAlertSnackBar({
        message: 'Logged out after 30 minutes of inactivity.',
        type: 'error',
      });
      this.flushUser();
    },
  },
};
</script>
